import { pageService } from './page-service';
import PageObjectDefaultPageInfo from './page-object-default-pageinfo';
import PageObjectDefaultCategory from './page-object-default-category';
import PageObjectDefaultAttributes from './page-object-default-attributes';

class PageObjectDefault {
	/**
	 * registers to ClickEventService
	 * @constructor singleton
	 */
	constructor() {
		if (PageObjectDefault._instance) {
			return PageObjectDefault._instance;
		}

		this.pagePageInfo = new PageObjectDefaultPageInfo();
		this.pageCategory = new PageObjectDefaultCategory();
		this.pageAttributes = new PageObjectDefaultAttributes();

		pageService.register(PageObjectDefault.getData, true);

		PageObjectDefault._instance = this;
	}

	/**
	 * getData - collects the tracking data
	 * @returns {Promise} promise - returns promise for pageObject
	 */
	static async getData() {
		let pageObject = {
			pageInfo: {
				pageID: PageObjectDefault._instance.pagePageInfo.getPageID(
					window.location.href,
					window.location.pathname,
				),
				pageName: PageObjectDefault._instance.pagePageInfo.getPageName(
					document,
				),
				destinationURL: PageObjectDefault._instance.pagePageInfo.getDestinationUrl(),
				referringURL: PageObjectDefault._instance.pagePageInfo.getReferringUrl(),
				sysEnv: PageObjectDefault._instance.pagePageInfo.getSysEnv(
					window.location.host,
				),
				breadCrumbs: PageObjectDefault._instance.pagePageInfo.getBreadCrumbs(
					window.location.href,
					window.location.pathname,
				),
				language: PageObjectDefault._instance.pagePageInfo.getLanguage(
					window.location.href,
					window.location.pathname,
				),
				market: PageObjectDefault._instance.pagePageInfo.getMarket(
					window.location.href,
					window.location.pathname,
				),
			},
			category: {
				pageType: PageObjectDefault._instance.pageCategory.getPageType(
					document,
				),
				displayType: PageObjectDefault._instance.pageCategory.getDisplayType(
					window.location.href,
				),
			},
			attributes: {
				applicationName: PageObjectDefault._instance.pageAttributes.getApplicationName(),
				applicationVersion: PageObjectDefault._instance.pageAttributes.getApplicationVersion(),
				implementer: PageObjectDefault._instance.pageAttributes.getImplementer(),
				site: PageObjectDefault._instance.pageAttributes.getSite(),
			},
		};

		return pageObject;
	}
}

/**
 * Singleton instance
 * @type {PageObjectDefault}
 * @private
 * @static
 */

const pageObjectDefault = new PageObjectDefault();

export { pageObjectDefault, PageObjectDefault };
